import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import ClustersInner from "./Clusters";

const Clusters = () => (
  <DatatableContextProvider>
    <ClustersInner />
  </DatatableContextProvider>
);

export { Clusters };
export { default as ClusterDetail } from "./ClusterDetail";
